export default __webpack_public_path__ + "static/blob1-794752b8cb92a74c773c8861db38160f.svg";